import styled from 'styled-components'

export const SectionForm = styled.section`
padding-block: 50px;
background-repeat: no-repeat;
background-position: center;
background-size: cover;

@media (min-width: 992px) {
overflow: hidden;
}

`
export const DivContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	.form-img { border-radius: var(--radius-6); }
`

export const ContainerDiv = styled.div`
display: grid;

@media (min-width: 992px) {
	grid-template-columns: 1fr 1fr;
	align-items: center;
}
`

export const FormContainer = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	padding-top:20px;
	margin: 0 auto;
  @media (min-width: 992px) {
    padding: 10px;
  }
`

export const FieldsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content:center;
	padding:0px;
`

export const Label = styled.label`
	margin-bottom: 5px;
`

export const Input = styled.input`
	padding: 8px;
	margin-bottom: 16px;
	border: 1px solid #ccc;
	border-radius: 4px;
	width: 85%;
	height: 30px;
	background-color: white;
`

export const Select = styled.select`

	padding: 8px;
	margin-bottom: 16px;
	border: 1px solid #ccc;
	border-radius: 4px;
	width: 80%;
	background-color: white;
`

export const TextArea = styled.textarea`
	padding: 8px;
	margin-bottom: 16px;
	border: 1px solid #ccc;
	border-radius: 4px;
	resize: none;
	width: 85%;
	height: 150px;
	background-color: white;
`

export const CheckboxLabel = styled.label`
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	font-size: var(--fs-6)
`

export const CheckboxInput = styled.input`
	width: 40px;
`

export const Button = styled.button`
  min-height: 60px;
  max-width: max-content;
  font-size: var(--fs-5);
  font-weight: var(--fw-700);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 30px;
  border-radius: var(--radius-6);
  transition: var(--transition-1);

	background-color: var(--ultramarine-blue);
	border: none;
	border-radius: 4px;
	cursor: pointer;
  color: var(--white);

	.btn-primary:is(:hover, :focus) { background-color: var(--space-cadet-2); }
`
